import React, { useRef, useEffect } from 'react';
import { MediaItem } from '.';
import styled from 'styled-components';
import { Card } from 'reactstrap';
import ActionIcon from '../../../components/custom/ActionIcon';

const VideoPreview = ({ src, previewTime = 1, className = '', ...props }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            // Set the video to the preview timestamp when metadata loads
            const handleMetadataLoad = () => {
                video.currentTime = Math.min(previewTime, video.duration || previewTime);
            };

            video.addEventListener('loadedmetadata', handleMetadataLoad);

            return () => {
                video.removeEventListener('loadedmetadata', handleMetadataLoad);
            };
        }
    }, [src, previewTime]);

    const handleClick = (e) => {
        // Prevent any default video behavior
        e.preventDefault();
        e.stopPropagation();
        // You can add custom click behavior here if needed
    };

    return (
        <video
            ref={videoRef}
            src={src}
            className={className}
            muted
            playsInline
            preload="metadata"
            onClick={handleClick}
            onContextMenu={(e) => e.preventDefault()} // Disable right-click menu
            style={{
                pointerEvents: 'none', // Completely disable interaction
                objectFit: 'cover',
                width: 250,
                maxHeight: 150,
                ...props.style
            }}
            {...props}
        />
    );
};

// Your DisplayCard component using the video preview
export default function DisplayCard({
    item,
    deleteFile
}: {
    item: MediaItem;
    deleteFile: (item: MediaItem) => Promise<void>;
}) {
    return (
        <Container>
                <FlexContainer>
                    <h6>{item.name}</h6>
                    <ActionIcon type={'delete'} onClick={() => deleteFile(item)} size={24} />
                </FlexContainer>
                {item.type === 'video' ? (
                    <VideoPreview
                        src={item.url}
                        previewTime={1} // Show frame at 1 second
                        className="w-full h-full"
                    />
                ) : (
                    <Thumbnail
                        src={item.url}
                        alt="Preview"
                        className="w-full h-full object-cover"
                    />
                )}
        </Container>
    );
};

const Container = styled(Card)`
    width: 310px;
    padding: 25px;
    border-radius: 25px;
`;

const Thumbnail = styled.img`
    width: 250px;
`;

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;